import {useEffect, useState} from 'react';
import {
    DndContext, 
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors
} from '@dnd-kit/core';

import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy
} from '@dnd-kit/sortable';

import {SortableBoardSetting} from './SortableBoardSetting';

export function SortableBoardSettings(props) {
    const [items, setItems] = useState([]);
    const [controller, setController] = useState([]);

    const sensors = useSensors(
            useSensor(PointerSensor),
            useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    useEffect(() => {
        if ( props.data ) {
            setItems(props.data);
        }

        if ( props.controller ) {
            setController(props.controller);
        }
    }, [props]);

    const renderItem = (id=-1, index=0) => {
        return (
            <SortableBoardSetting 
                key={id.id} 
                id={id.id} 
                data={items[index]} 
                boardTypes= { props.boardTypes ? props.boardTypes : [] }  
                controller={ controller }
                parentEditMode={ props.editMode }
                handle
            />
        );
    }
    
    const handleDragEnd = (event) => {
        const {active, over} = event;    
    
        if (active.id !== over.id) {

            const swapElements = (items) => {
                const oldIndex = items.findIndex(item => item.id === active.id);
                const newIndex = items.findIndex(item => item.id === over.id);

                return arrayMove(items, oldIndex, newIndex);
            }

            const newItems = swapElements(items);
            setItems(newItems)

            const orderList = newItems.map(obj => obj.id);
            
            updateBoardsOrder(orderList);
        }
    }

    const updateBoardsOrder = (boardIds=[]) => {
        controller.updateBoardsOrder(boardIds);
    }

    return (
        <DndContext 
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
        >
            <SortableContext 
                items={items}
                strategy={verticalListSortingStrategy}
            >
                {items.map((id, index) => renderItem(id, index))}
            </SortableContext>
        </DndContext>
    );
}